import { capitalize } from 'utils/string';

export const ALL_KEY = 'all';

export const ALL_LABEL = capitalize(ALL_KEY);

export const NONE_LABEL = 'None selected';
